import React,{useEffect,useRef} from "react";
import e1 from "../assets/eCardW.svg";
import e2 from "../assets/eCardY.svg";
import e3 from "../assets/eCardR.svg";
import hat from "../assets/hat.svg";
import plane from "../assets/plane.svg";
import line from "../assets/line.svg";
import money from "../assets/money.svg";
import video from "../assets/video.svg";
import cal from "../assets/cal.svg";
import gift from "../assets/gift.svg";
import mail from "../assets/mail.svg";
import stary from "../assets/starsY.svg";
import starr from "../assets/startR.svg";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);


const PriceCards = () => {
  const card1 = useRef(null);
  const card2 = useRef(null);
  const card3 = useRef(null);

  useEffect(() => {
    // Set initial state for all cards
    gsap.set([card1.current, card2.current, card3.current], { opacity: 0, y: 100 });

    // Create a timeline for staggered animations
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: card1.current, // Trigger the animation when card1 enters the viewport
        start: "top 80%", // Animation starts when the top of card1 reaches 80% of the viewport
        end: "bottom top", // Animation ends when the bottom of card1 reaches the top of the viewport
        toggleActions: "play none none none", // Play on enter, reverse on leave
      },
    });

    // Add staggered animations to the timeline
    tl.to(card1.current, { opacity: 1, y: 0, duration: 0.4 }, "<") // Start immediately
      .to(card2.current, { opacity: 1, y: 0, duration: 0.4 }, "+=0.1") // Delay by 0.5 seconds
      .to(card3.current, { opacity: 1, y: 0, duration: 0.4 }, "+=0.1"); // Delay by another 0.5 seconds
  }, []);

  return (
    <div className="flex flex-col md:flex-row justify-between my-10 w-75 md:w-90 md:space-x-6 space-y-6 md:space-y-0">
      {/* Silver Plan */}
      <div ref={card1} className="w-full h-[580px] md:h-auto  md:w-2/6 flex-col border-[1.5px] border-greyL rounded-3xl bg-carbon">
        <img className="flex ml-auto md:w-[120px] xl:w-[200px] w-[120px]" src={e1} alt="Logo Estudy" />
        <div className="w-90 ml-4 xl:ml-8 bg-greyD w-fit rounded-full py-1 px-2">
          <div className="bg-custom-grey text-transparent bg-clip-text">
            <p className="text-8 xl:text-14">Essentials</p>
          </div>
        </div>
        <p className="text-grey md:text-18 xl:text-25 font-medium w-90 ml-4  xl:ml-8 my-2">
          Silver Plan
        </p>
        <p className="text-9 md:text-12 md:leading-12 xl:text-14 text-white font-normal w-85 ml-4  xl:ml-8">
          This plan offers the most essential features to make sure you are on your track to study abroad.
        </p>
        <p className="text-32 font-semibold md:text-27 xl:text-64 text-white ml-4 xl:ml-8 my-4">
        €400.<span className="text-grey">00</span>
        </p>
        <a
          href="https://wa.link/eaoxxu"
          target="_blank" rel="noopener noreferrer"
          className="text-9 md:text-9 xl:text-15 text-grey font-normal w-90 mx-auto block text-center my-4 py-2 xl:py-3 border-[1.5px] border-greyL rounded-lg bg-greyButton"
        >
          Apply Now
        </a>
        <div className="flex w-90 mx-auto my-6 md:my-5 xl:my-10 space-x-1 md:space-x-3 xl:space-x-8">
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
          <p className="text-grey text-9 md:text-9 xl:text-12">Features</p>
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
        </div>
        <div className="flex items-center h-8 md:h-6 xl:h-10">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={hat} alt="" />
          <p className="text-white text-9 md:text-11 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            University Acceptance
          </p>
        </div>
        <div className="flex items-center h-8 md:h-6 xl:h-10 mb-2">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={plane} alt="" />
          <p className="text-white text-9 md:text-11 xl:text-14 ml-[-8px] md:ml-[-10px] xl:ml-[-10px] pt-1">
            Visa Support
          </p>
        </div>
      </div>

      {/* Gold Plan */}
      <div ref={card2} className="w-full md:w-2/6 flex-col border-[1.5px] border-greyL rounded-3xl bg-carbon pb-6 md:pb-10 xl:pb-10 overflow-hidden">
        <img className="flex ml-auto md:w-[120px] xl:w-[200px] w-[120px]" src={e2} alt="Logo Estudy" />
        <div className="flex w-90 ml-4 md:ml-4 xl:ml-8 bg-greyD w-fit rounded-full py-1 px-2 mt-[-20px] md:mt-[-10px] xl:mt-[-30px]">
          <img className="w-3 xl:w-auto" src={stary} alt="" />
          <div className="bg-custom-grey text-transparent bg-clip-text ml-1">
            <p className="text-8 xl:text-14">Best plan</p>
          </div>
        </div>
        <p className="text-gold md:text-18 xl:text-25 font-medium w-90 ml-4 md:ml-4 xl:ml-8 my-2">
          Gold Plan
        </p>
        <p className="text-9 md:text-12 md:leading-12 xl:text-14 text-white font-normal w-85 ml-4 md:ml-4 xl:ml-8">
          This plan offers more than just the essential features to support you through the way!
        </p>
        <p className="text-27 font-semibold md:text-32 xl:text-64 text-white ml-4 md:ml-4 xl:ml-8 my-4">
        €700.<span className="text-grey">00</span>
        </p>
        <a
          href="https://wa.link/eaoxxu"
          target="_blank" rel="noopener noreferrer"
          className="text-9 md:text-9 xl:text-15 text-grey font-normal w-90 mx-auto block text-center my-4 py-2 xl:py-3 border-[1.5px] border-greyL rounded-lg bg-goldButton"
        >
          Apply Now
        </a>
        <div className="flex w-90 mx-auto my-6 md:my-5 xl:my-10 space-x-1 md:space-x-3 xl:space-x-8">
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
          <p className="text-grey text-9 md:text-9 xl:text-12">Features</p>
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
        </div>
        <div className="flex items-center h-8 md:h-7 xl:h-10">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={hat} alt="" />
          <p className="text-white text-9 md:text-12 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            University Acceptance
          </p>
        </div>
        <div className="flex items-center h-8 md:h-7 xl:h-10 mb-2">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={plane} alt="" />
          <p className="text-white text-9 md:text-12 xl:text-14 ml-[-8px] md:ml-[-10px] xl:ml-[-10px] pt-1">
            Visa Support
          </p>
        </div>
        <div className="flex w-90 mx-auto my-6 md:my-5 xl:my-10 space-x-1 md:space-x-3 xl:space-x-8">
          <img className="w-16 md:w-10 xl:w-20" src={line} alt="" />
          <img className="w-6 md:w-6 xl:w-auto" src={stary} alt="" />
          <p className="text-grey text-9 md:text-9 xl:text-12">
            <span className="font-bold">Premium</span>
            <br />
            Features
          </p>
          <img className="w-16 md:w-10 xl:w-20 " src={line} alt="" />
        </div>
        <div className="flex items-center h-8 md:h-8 xl:h-10">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={cal} alt="" />
          <p className="text-white text-9 md:text-11 md:w-70 xl:w-full md:leading-12 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            SIM Card: Help with acquiring the SIM
          </p>
        </div>
        <div className="flex items-center h-8 md:h-8 xl:h-10">
          <img className="w-4 xl:w-6 mx-4  xl:mx-8" src={money} alt="" />
          <p className="text-white text-9 md:text-11 md:leading-12 xl:text-14 ml-[-8px] md:ml-[-10px] xl:ml-[-10px] pt-1">
            Bank Account: Assist opening it
          </p>
        </div>
        <div className="flex items-center h-8 md:h-8 xl:h-10">
          <img className="w-4 xl:w-6 mx-4 xl:mx-8" src={gift} alt="" />
          <p className="text-white text-9 md:text-11 md:w-70 md:leading-12 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            Accommodation - Help you get a house
          </p>
        </div>
      </div>

      {/* Premium Plan */}
      <div ref={card3} className="w-full h-[580px] md:h-auto md:w-2/6 flex-col border-[1.5px] border-greyL rounded-3xl bg-carbon pb-6 md:pb-10 xl:pb-10 overflow-hidden">
        <img className="flex ml-auto md:w-[120px] xl:w-[200px] w-[120px]" src={e3} alt="Logo Estudy" />
        <div className="flex w-90 ml-4 md:ml-4 xl:ml-8 bg-greyD w-fit rounded-full py-1 px-2 mt-[-30px] md:mt-[-30px] xl:mt-[-55px]">
          <img className="w-3 xl:w-auto" src={starr} alt="" />
          <div className="bg-custom-grey text-transparent bg-clip-text ml-1">
            <p className="text-8 xl:text-14">Super Premium Plan</p>
          </div>
        </div>
        <p className="text-red md:text-18 xl:text-25 font-medium w-90 ml-4 md:ml-4 xl:ml-8 my-2">
          Premium
        </p>
        <p className="text-9 md:text-12 md:leading-12 xl:text-14 text-white font-normal w-85 ml-4 md:ml-4 xl:ml-8">
          This plan offers all our features and assistance at a premium level while still being affordable.
        </p>
        <p className="text-27 font-semibold md:text-32 xl:text-64 text-white ml-4 md:ml-4 xl:ml-8 my-4">
        €900.<span className="text-grey">00</span>
        </p>
        <a
          href="https://wa.link/eaoxxu"
          target="_blank" rel="noopener noreferrer"
          className="text-9 md:text-9 xl:text-15 text-grey font-normal w-90 mx-auto block text-center my-4 py-2 xl:py-3 border-[1.5px] border-greyL rounded-lg bg-redButton"
        >
          Apply Now
        </a>
        <div className="flex w-90 mx-auto my-6 md:my-5 xl:my-10 space-x-1 md:space-x-3 xl:space-x-8">
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
          <p className="text-grey text-9 md:text-9 xl:text-12">Features</p>
          <img className="w-40 md:w-35 xl:w-45" src={line} alt="" />
        </div>
        <div className="flex items-center h-8 md:h-8 xl:h-10">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={hat} alt="" />
          <p className="text-white text-9 md:text-11 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            University Acceptance
          </p>
        </div>
        <div className="flex items-center h-8 md:h-5 xl:h-10 mb-2">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4  xl:mx-8" src={plane} alt="" />
          <p className="text-white text-9 md:text-11 xl:text-14 ml-[-8px] md:ml-[-10px] xl:ml-[-10px] pt-1">
            Visa Support
          </p>
        </div>
        <div className="flex items-center h-8 md:h-5 xl:h-10 mb-2">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4 xl:mx-8" src={mail} alt="" />
          <p className="text-white text-11 md:text-11 xl:text-14 ml-[-8px] md:ml-[-10px] xl:ml-[-10px] pt-1">
          All-Features in Gold
          </p>
        </div>
        <div className="flex w-90 mx-auto my-6 md:my-5 xl:my-10 space-x-1 md:space-x-3 xl:space-x-8">
          <img className="w-16 md:w-10 xl:w-20" src={line} alt="" />
          <img className="w-6 md:w-6 xl:w-auto" src={starr} alt="" />
          <p className="text-grey text-9 md:text-9 xl:text-12">
            <span className="font-bold">Premium</span>
            <br />
            Features
          </p>
          <img className="w-16 md:w-10 xl:w-20" src={line} alt="" />
        </div>
        <div className="flex w-90 ml-4 xl:ml-8 bg-greyD w-fit rounded-full py-1 px-2 mb-2">
          <img className="w-3 xl:w-auto" src={starr} alt="" />
          <div className="bg-custom-grey text-transparent bg-clip-text ml-1">
            <p className="text-8 xl:text-14">Airport Pickup</p>
          </div>
        </div>
        <div className="flex items-center h-8 md:h-10 xl:h-10">
          <img className="w-4 xl:w-6 h-6 md:h-6 xl:h-6 mx-4 xl:mx-8" src={video} alt="" />
          <p className="text-white text-11 xl:text-14 ml-[-8px] md:ml-[-12px] xl:ml-[-12px] pt-1">
            Tour of the City
          </p>
        </div>
      </div>
    </div>
  );
};

export default PriceCards;